import * as Sentry from "@sentry/react";

export const SUPPORT_CONFIG = {
  IS_ENABLED: import.meta.env.VITE_SUPPORT_IS_ENABLED === "true",
};

/**
 * Address of the screen being reported: origin + pathname, not the full href — a query string
 * can carry tokens and personal data (e.g. `?token=` from the OAuth callback), which sending
 * would park permanently in the ticket and in Sentry. Support only needs the environment and
 * the screen.
 */
export const getReportableUrl = () =>
  `${window.location.origin}${window.location.pathname}`;

/** `tel:` rejects the spaces the displayed number is grouped with. The number itself lives
    in the dictionaries, so a market can carry its own support line. */
export const toTelHref = (phoneNumber: string) =>
  `tel:${phoneNumber.replaceAll(" ", "")}`;

/**
 * Whether the technical-problem branch has anywhere to send a report. With the Sentry SDK
 * uninitialised (VITE_SENTRY_IS_ENABLED=false, e.g. local dev) it does not, and offering a
 * choice that can only ever end in an error screen is worse than showing it as unavailable.
 */
export const isTechnicalReportAvailable = () => Sentry.isInitialized();
